//////////////////////////////////////////////////////////////////////////////////////////////////
// teeInBlue.js – Enforce SKU injection into TeeInBlue personalization field
//////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Get the selected variant SKU from ShopifyAnalytics
 */
function getSelectedVariantSKU() {
	const selectedId = window.ShopifyAnalytics?.meta?.selectedVariantId;
	const variants = window.ShopifyAnalytics?.meta?.product?.variants;

	if (!selectedId || !variants) return null;

	const match = variants.find(v => String(v.id) === String(selectedId));
	return match?.sku || null;
}

/**
 * Inject the SKU into #layer-795375 if available
 */
function injectSKU() {
	const sku = getSelectedVariantSKU();
	if (!sku) return;

	const field = document.getElementById("layer-795375");
	if (field) {
		field.value = sku;
		console.log("[teeInBlue] Injected SKU:", sku);
	}
}

/**
 * Wait until both ShopifyAnalytics and the field are ready
 */
function initWhenReady(attempt = 0) {
	const field = document.getElementById("layer-795375");
	const hasAnalytics = !!(window.ShopifyAnalytics?.meta?.selectedVariantId && window.ShopifyAnalytics?.meta?.product?.variants);

	if (field && hasAnalytics) {
		injectSKU();
		observeVariantChange();
		addAriaLabel();
	} else if (attempt < 20) {
		console.log("[teeInBlue] Waiting for field + analytics...", attempt);
		setTimeout(() => initWhenReady(attempt + 1), 500);
	} else {
		console.error("[teeInBlue] Gave up waiting for field or analytics.");
	}

	// Adjust sizing/positioning of the form wrapper (Tablet and up)
	const viewPort = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if ( field && viewPort >= 768 ) {
		const qtyInput = document.querySelector('.product-info__quantity-selector').getBoundingClientRect();
		const qtyInputWidth = qtyInput.width + 10
		const formWrap = document.querySelector('.tee-campaign-form-wrapper');
		formWrap.style.cssText = `width:calc(100% + ${qtyInputWidth}px );transform:translateX(-${qtyInputWidth}px);`;
	}
}

/**
 * Watch for variant switching
 */
function observeVariantChange() {
	let currentVariantId = window.ShopifyAnalytics?.meta?.selectedVariantId;

	const observer = new MutationObserver(() => {
		const newVariantId = window.ShopifyAnalytics?.meta?.selectedVariantId;
		if (newVariantId && String(newVariantId) !== String(currentVariantId)) {
			currentVariantId = newVariantId;
			console.log("[teeInBlue] Variant changed →", newVariantId);
			injectSKU();
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
}

/**
 * Failsafe: Every 500ms, check if field still has the correct SKU
 */
function enforceSKUIntegrity() {
	setInterval(() => {
		const field = document.getElementById("layer-795375");
		const sku = getSelectedVariantSKU();

		if (!field || !sku) return;

		if (field.value !== sku) {
			console.log("[teeInBlue] Field value mismatch. Re-applying SKU:", sku);
			field.value = sku;
		}
	}, 1000);
}


function wrapPhotoFieldsWhenReady() {
	const MAX_ATTEMPTS = 10;
	const INTERVAL = 500;
	let attempt = 0;

	const intervalId = setInterval(() => {
		const form = document.getElementById("teeFormInputs");
		if (!form) {
			console.warn("[teeInBlue]  Waiting for #teeFormInputs...");
			attempt++;
			if (attempt >= MAX_ATTEMPTS) clearInterval(intervalId);
			return;
		}

		const photoFields = Array.from(form.querySelectorAll(".tee-field--photo"));
		if (photoFields.length === 0) {
			console.warn("[teeInBlue] Waiting for .tee-field--photo fields...");
			attempt++;
			if (attempt >= MAX_ATTEMPTS) clearInterval(intervalId);
			return;
		}

		if (form.querySelector(".photo-fields-flex-wrapper")) {
			console.log("[teeInBlue]  Wrapper already exists. Skipping.");
			clearInterval(intervalId);
			return;
		}

		// Create wrapper and insert
		const wrapper = document.createElement("div");
		wrapper.className = "photo-fields-flex-wrapper";
		form.insertBefore(wrapper, photoFields[0]);
		photoFields.forEach(field => wrapper.appendChild(field));

		console.log("[teeInBlue] ✅ Wrapper inserted successfully");
		clearInterval(intervalId);
	}, INTERVAL);
}

/**
 * Moves the first .form-control div into the first .tee-block div
 */
function moveFormControlIntoTeeBlock() {
	const MAX_ATTEMPTS = 10;
	const INTERVAL = 500;
	let attempt = 0;

	const intervalId = setInterval(() => {
		const formControl = document.querySelector('.form-control');
		const teeBlock = document.querySelector('.tee-block');

		if (!formControl || !teeBlock) {
			console.warn('[teeInBlue] Waiting for .form-control or .tee-block...');
			attempt++;
			if (attempt >= MAX_ATTEMPTS) clearInterval(intervalId);
			return;
		}

		// Move the form-control into tee-block if not already moved
		if (!teeBlock.contains(formControl)) {
			teeBlock.appendChild(formControl);
			console.log('[teeInBlue] ✅ Moved .form-control into .tee-block');
		} else {
			console.log('[teeInBlue] .form-control already inside .tee-block. Skipping.');
		}

		clearInterval(intervalId);
	}, INTERVAL);
}

/**
 * Adds aria-labels to select elements
 */
function addAriaLabel() {
	const selects = document.querySelectorAll('.tee-field__select');
	console.log('selects found:', selects);
	selects.forEach(select => {
		if (!select.hasAttribute('aria-label')) {
			const firstOption = select.querySelector('option');
			const label = firstOption.label || firstOption.textContent;
			console.log('label', label);

			select.setAttribute('aria-label', label);
			console.log(`[teeInBlue] ✅ Added aria-label="${label}" to select.`);
		}
	});
}



document.addEventListener("DOMContentLoaded", () => {
	console.log("✅ teeInBlue.js started.");

	initWhenReady();        // Handle first load
	enforceSKUIntegrity();  // Keep it locked in
	wrapPhotoFieldsWhenReady();
	moveFormControlIntoTeeBlock();

});
